import React from "react";
import reportWebVitals from "./reportWebVitals";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AliveScope } from 'react-activation'
import './flexible.js';
import '@/assets/font/font.css'

// App/WebView 用 hash 打开合成页时，转成 BrowserRouter 可识别的 path
(() => {
  const hash = window.location.hash || '';
  if (!hash.startsWith('#/collectionSynthesis')) return;
  const hashUrl = hash.slice(1);
  const [hashPath, hashQuery = ''] = hashUrl.split('?');
  const merged = new URLSearchParams(window.location.search);
  new URLSearchParams(hashQuery).forEach((value, key) => {
    if (!merged.has(key)) merged.set(key, value);
  });
  const nextSearch = merged.toString();
  window.history.replaceState(null, '', `${hashPath}${nextSearch ? `?${nextSearch}` : ''}`);
})();

const rootElement = document.getElementById("root");
render(
  // <React.StrictMode>
  <BrowserRouter>
    <AliveScope>
      <App />
    </AliveScope>
  </BrowserRouter>,
  // </React.StrictMode>,
  rootElement
);
if(process.env.REACT_APP_ERUDA) {
  window.eruda.init()
}
reportWebVitals();
